import { render, staticRenderFns } from "./buildCorreos.vue?vue&type=template&id=fb210e5e&scoped=true"
import script from "./buildCorreos.vue?vue&type=script&lang=js"
export * from "./buildCorreos.vue?vue&type=script&lang=js"
import style0 from "./buildCorreos.vue?vue&type=style&index=0&id=fb210e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb210e5e",
  null
  
)

export default component.exports